import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootState } from '../../../redux/store';
import axiosInstance from '../../../api/axiosInstance';
import endpoints from '../../../api/endpoints';

interface ArticleToSend {
  reference: string;
  description: string;
  unite: string;
  prix: number;
  quantite: number;
}

interface PrecommandeInput {
  clientId: string | undefined;
  siteVenteId: string | undefined;
  siteExpId: string | undefined;
  articles: ArticleToSend[];
  userId: string;
}

interface PrecommandeState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  precommandeId: number | null;
}

const initialState: PrecommandeState = {
  status: 'idle',
  error: null,
  precommandeId: null,
};

export const savePrecommande = createAsyncThunk(
  'precommande/savePrecommande',
  async (data: PrecommandeInput, {getState}) => {
    const state = getState() as RootState;

    const language = state.languageSlice.language;
    
    const response = await axiosInstance.post(
      endpoints.commandes.SavePrecommandeByRepresenatant,
      data,
      {
        headers: {
          "Accept-Language": language,
        },
      }
    );    
    return response.data;
  }
);

const precommandeSlice = createSlice({
  name: 'precommande',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(savePrecommande.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(savePrecommande.fulfilled, (state, action: PayloadAction<number>) => {
        state.status = 'succeeded';
        state.precommandeId = action.payload;
      })
      .addCase(savePrecommande.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Failed to save precommande';
      });
  },
});

export default precommandeSlice.reducer;
